import React from 'react';
import { Route, Switch } from 'react-router-dom';

// Constants
import { configs } from '../constants/configs/configs';

// components
import AccessCodeContainer from '../components/accessCode/AccessCodeContainer';
import EDESearchAndSelfDesignationContainer from '../components/broker/edeSearchAndDesignation/EDESearchAndSelfDesignationContainer';
import HomeContainer from '../components/anonymous/home/HomeContainer';
import ArchiveHouseholdContainer from '../modules/archive-household';

// Modules

import { GeorgiaAccessDashboardContainer } from '../modules/georgia-access';
import { GAEPInsCompany, GAEPWebBroker } from '../modules/georgia-access/gaep';
import { AgentListing } from '../modules/georgia-access/agent-listing';
import AgentDetails from '../modules/georgia-access/agent-listing/agent-details';

function GARoutes() {
    const {
        routes: {
            ACCESS_CODE,
            ANON_GA_AGENTS,
            ANON_GA_CARRIERS,
            ANON_GA_GAEPS,
            ARCHIVE_HOUSEHOLD,
            EDE_ID_PROOFING,
            HOME,
            INDPORTAL,
        },
    } = configs;

    return (
        <Switch>
            <Route path={ACCESS_CODE} exact component={AccessCodeContainer} />
            <Route path={ARCHIVE_HOUSEHOLD} exact component={ArchiveHouseholdContainer} />
            <Route path={EDE_ID_PROOFING} exact component={EDESearchAndSelfDesignationContainer} />
            <Route path={EDE_ID_PROOFING} component={EDESearchAndSelfDesignationContainer} />
            <Route path={HOME} exact component={HomeContainer} />
            <Route path={ANON_GA_AGENTS} exact component={AgentListing} />
            <Route path={`${ANON_GA_AGENTS}/:agentId`} exact={false} component={AgentDetails} />
            <Route path={ANON_GA_CARRIERS} exact component={GAEPInsCompany} />
            <Route path={ANON_GA_GAEPS} exact component={GAEPWebBroker} />
            <Route path={INDPORTAL} component={GeorgiaAccessDashboardContainer} />
        </Switch>
    );
}

export { GARoutes };
